import { render, staticRenderFns } from "./detailFirst.vue?vue&type=template&id=14206376&scoped=true"
import script from "./detailFirst.vue?vue&type=script&lang=js"
export * from "./detailFirst.vue?vue&type=script&lang=js"
import style0 from "./detailFirst.vue?vue&type=style&index=0&id=14206376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14206376",
  null
  
)

export default component.exports